module.exports = __webpack_public_path__ + "img/BN.7b31105b.svg";